export const ERR_API_CALL_TRANSCRIPTS_NOT_READY =
  'ERR_API_CALL_TRANSCRIPTS_NOT_READY';

export const ERR_HTTP_TIMEOUT = 'ERR_HTTP_TIMEOUT';
export const ERR_HTTP_CIRCUIT_OPEN = 'ERR_HTTP_CIRCUIT_OPEN';

export const CANCEL_WRAPUP_FAILED = 'CANCEL_WRAPUP_FAILED';
export const UPDATE_STATUS_FAILED = 'UPDATE_STATUS_FAILED';
